// extracted by mini-css-extract-plugin
export default {"fs":"e73baf1682 b79943535b"};